"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResolveDriversLicenceWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var core_1 = require("@athena-portal/core");
var services_1 = require("@falcon/services");
var React = require("react");
var components_1 = require("@athena-portal/components");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var drivingLicenceHelper_1 = require("../../helpers/drivingLicenceHelper");
var journey_services_1 = require("@athena-portal/journey-services");
var MobileDetect = require("mobile-detect");
var Types_1 = require("../../Types");
var imageResizeHelper_1 = require("../../helpers/imageResizeHelper");
var reactstrap_1 = require("reactstrap");
var ResolveDriversLicenceWidget = /** @class */ (function (_super) {
    __extends(ResolveDriversLicenceWidget, _super);
    function ResolveDriversLicenceWidget(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.drivers = [];
        _this.temporaryDrivers = [];
        _this.inputID = "dl-widget-upload-input-front";
        _this.firstNameID = "firstName";
        _this.showInfoHandler = function () {
            _this.setState({ showInfo: !_this.state.showInfo });
        };
        _this.focusOnFirstNameField = function () {
            var firstNameInputField = document.getElementById(_this.firstNameID);
            if (firstNameInputField) {
                firstNameInputField.focus();
                firstNameInputField.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        };
        _this.renderDrivingLicenceUploadInfoText = function () {
            return ((0, jsx_runtime_1.jsx)("div", { className: "widget collapse-label-widget mb-3", children: (0, jsx_runtime_1.jsx)("div", { className: "shadow-none", children: (0, jsx_runtime_1.jsxs)("p", { className: "font-weight-normal m-0", children: ["Save time and skip the form: just take a photo of front of your UK driving", ' ', "licence, upload it, and we'll do the rest. Don't worry: ", (0, jsx_runtime_1.jsx)("b", { children: "we don't store or share your licence image." })] }) }) }));
        };
        _this.renderDrivingLicenceUploadOptions = function () {
            return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [!_this.state.videoStart && _this.renderDrivingLicenceUpload(), ";", (0, jsx_runtime_1.jsxs)("div", { className: "dl-widget-full-screen-panel", id: "orient-landscape-fullscreen", children: [_this.state.videoStart ? _this.renderVideo() : _this.renderEmptyVideoBackground(), (0, jsx_runtime_1.jsx)("div", { className: "dl-widget-question-panel", id: "orient-landscape-question", children: (0, jsx_runtime_1.jsxs)("div", { className: "dl-widget-video-capture-rules", children: [(0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("div", { className: "dl-widget-question", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { className: "mb-1 mr-2 dl-widget-question-image", src: "/img/tick.svg", alt: "Green tick picture" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { className: "dl-widget-question-paragraph", children: "Take the picture in good light with no glare on the licence" }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: "dl-widget-question", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { className: "mb-1 mr-2 dl-widget-question-image", src: "/img/tick.svg", alt: "Green tick picture" }) }), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("p", { className: "dl-widget-question-paragraph", children: "Make sure it's a valid UK licence" }) })] })] }), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("button", { className: "btn btn-primary btn-add dl-btn-next-width dl-btn-next-center", onClick: _this.state.videoStart ? _this.capturePicture : function () { return _this.setState({ videoStart: true }); }, children: "Take photo" }), (0, jsx_runtime_1.jsx)("input", { onKeyPress: _this.getFrontFile, role: "button", tabIndex: 0, type: "file", id: _this.inputID, className: "dl-widget-upload-input", onChange: _this.getFrontFile }), (0, jsx_runtime_1.jsx)("label", { htmlFor: _this.inputID, className: "btn btn-white dl-btn-next-width mb-0 dl-btn-next-center", role: "button", tabIndex: 0, children: "Use Photo Library" })] })] }) })] }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: _this.state.showOverlay })] }));
        };
        _this.renderVideo = function () {
            _this.disableFalconFooterAndBodyScrolling(true);
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)("div", { className: "dl-widget-video-panel", children: [(0, jsx_runtime_1.jsx)("img", { id: "video-image", className: "dl-widget-video-image", src: "/img/driving-licence.svg", alt: "Example of driving licence frame" }), (0, jsx_runtime_1.jsx)("video", { className: "dl-widget-video-box", ref: _this.videoRef, playsInline: true, id: "video", width: "100%", height: "100%", autoPlay: true, muted: true })] }) }));
        };
        _this.renderEmptyVideoBackground = function () {
            return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsx)("div", { className: "dl-widget-video-background" }) }));
        };
        _this.stopVideoStream = function () {
            if (_this.videoStream && _this.videoStream.active) {
                _this.videoStream.getTracks().forEach(function (track) { return track.stop(); });
            }
            _this.setState({
                videoStart: false,
                mobileUploadOptions: false
            });
        };
        var licenceID = _this.getSetting("licenceID", undefined);
        if (licenceID) {
            _this.licenceID = licenceID;
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget missing 'licenceID' setting"));
        }
        var journeyState = _this.props.engine.getJourneyState();
        _this.state = {
            frontIsUploaded: journeyState["".concat(_this.licenceID, "DLFrontResolved")] || null,
            frontIsResolved: journeyState["".concat(_this.licenceID, "DLFrontResolved")] || null,
            frontIsUKType: journeyState["".concat(_this.licenceID, "DLFrontIsUKType")] || null,
            duplicateDriverFound: journeyState["".concat(_this.licenceID, "DuplicateDriverFound")] || false,
            licenceNotResolved: journeyState["".concat(_this.licenceID, "LicenceNotResolved")] || false,
            imageExtensionIsCorrect: journeyState["".concat(_this.licenceID, "ImageExtensionIsCorrect")] || true,
            frontFile: null,
            driverAddress: null,
            uploadedFile: null,
            showOverlay: false,
            licenceNumberValid: false,
            videoStart: false,
            mobileUploadOptions: false,
            showInfo: false,
            showStartingPage: true,
            isMobileScreenSize: window.innerWidth < 768,
            licenceNumberFieldName: "",
            showUploadImageModal: false
        };
        _this.props.engine.setJourneyState((_a = {},
            _a["".concat(_this.licenceID, "DLFrontResolved")] = _this.state.frontIsUploaded,
            _a["".concat(_this.licenceID, "DLFrontIsUKType")] = _this.state.frontIsUKType,
            _a["".concat(_this.licenceID, "DuplicateDriverFound")] = _this.state.duplicateDriverFound,
            _a["".concat(_this.licenceID, "ImageExtensionIsCorrect")] = _this.state.imageExtensionIsCorrect,
            _a["hidePageValidationErrorMessage"] = false,
            _a));
        _this.videoRef = React.createRef();
        _this.videoStream = null;
        _this.falconFooter = undefined;
        _this.getFrontFile = _this.getFrontFile.bind(_this);
        _this.capturePicture = _this.capturePicture.bind(_this);
        _this.videoStreamIsDeclined = _this.videoStreamIsDeclined.bind(_this);
        _this.isMobile = _this.isMobile.bind(_this);
        _this.handleResolveFront = _this.handleResolveFront.bind(_this);
        _this.bindFromField = _this.bindFromField.bind(_this);
        _this.getSetting = _this.getSetting.bind(_this);
        _this.validateDuplicateDrivers = _this.validateDuplicateDrivers.bind(_this);
        _this.validateLicenceNumber = _this.validateLicenceNumber.bind(_this);
        _this.renderDrivingLicenceUpload = _this.renderDrivingLicenceUpload.bind(_this);
        _this.renderUploadedDrivingLicenceOutput = _this.renderUploadedDrivingLicenceOutput.bind(_this);
        _this.toggleUploadImageModal = _this.toggleUploadImageModal.bind(_this);
        _this.exitUploadImageModal = _this.exitUploadImageModal.bind(_this);
        window.addEventListener("resize", _this.resize.bind(_this));
        return _this;
    }
    ResolveDriversLicenceWidget.prototype.componentDidUpdate = function () {
        var _this = this;
        if (this.state.videoStart && !(this.videoStream && this.videoStream.active)) {
            // getting access to webCam
            navigator.mediaDevices
                .getUserMedia({
                video: { facingMode: 'environment' },
                audio: false
            })
                .then(function (stream) {
                _this.videoRef.current.srcObject = stream;
                _this.videoStream = stream;
            })
                .catch(function (error) { return _this.videoStreamIsDeclined(error); });
        }
    };
    ResolveDriversLicenceWidget.prototype.componentWillUnmount = function () {
        this.stopVideoStream();
    };
    ResolveDriversLicenceWidget.prototype.render = function () {
        this.disableFalconFooterAndBodyScrolling(false);
        if (this.state.frontIsUploaded) {
            var imageSource = this.state.frontFile;
            if (imageSource && !this.state.mobileUploadOptions && !this.state.showStartingPage) {
                var uploadedImage = (0, jsx_runtime_1.jsx)("img", { src: imageSource.base64, className: "dl-uploaded-image", alt: "Uploaded image" });
                return (this.renderUploadedDrivingLicenceOutput(uploadedImage));
            }
            else {
                return (this.state.mobileUploadOptions ? this.renderDrivingLicenceUploadOptions() : this.renderDrivingLicenceUpload());
            }
        }
        else {
            return (this.state.mobileUploadOptions ? this.renderDrivingLicenceUploadOptions() : this.renderDrivingLicenceUpload());
        }
    };
    ResolveDriversLicenceWidget.prototype.getFrontFile = function (event) {
        var _a, _b;
        var _this = this;
        if (this.isMobile()) {
            this.stopVideoStream();
            this.props.engine.setJourneyState({ videoStreamEnabled: true });
        }
        var file = event.target.files[0];
        if (file) {
            this.toggleOverlay(true);
            if (file.type === "image/jpeg" || file.type === "image/jpg" || file.type === "image/png" || file.type === "image/gif" || file.type === "image/bmp") {
                this.props.engine.setJourneyState((_a = {},
                    _a["".concat(this.licenceID, "ImageExtensionIsCorrect")] = true,
                    _a));
                var reader_1 = new FileReader();
                reader_1.readAsDataURL(file);
                reader_1.onload = function () {
                    imageResizeHelper_1.default.checkAndResize(file, reader_1.result).then(function (contents) {
                        _this.setState({
                            frontFile: {
                                base64: contents
                            },
                            uploadedFile: file,
                            frontIsUploaded: true,
                            showStartingPage: false,
                            showUploadImageModal: true
                        });
                        _this.toggleOverlay(false);
                    });
                };
            }
            else {
                this.setState({
                    frontIsUploaded: false,
                    showStartingPage: true
                });
                this.props.engine.setJourneyState((_b = {},
                    _b["".concat(this.licenceID, "ImageExtensionIsCorrect")] = false,
                    _b));
                this.props.engine.validate();
                this.toggleOverlay(false);
            }
        }
    };
    ResolveDriversLicenceWidget.prototype.handleResolveFront = function () {
        var _this = this;
        this.toggleOverlay(true);
        if (this.state.frontFile) {
            this.falconConvenienceApiService.analyzeDriversLicenceFront(this.state.frontFile.base64, this.props.engine.getInteraction()._id)
                .subscribe(function (output) {
                var _a;
                var drivingLicenceDetails = output;
                if (drivingLicenceDetails && drivingLicenceDetails.licenceNumber && _this.licenceID !== "AH") {
                    _this.validateDuplicateDrivers(drivingLicenceDetails.licenceNumber);
                }
                if (!drivingLicenceDetails || drivingLicenceDetails.errorMessage) {
                    _this.setState({
                        frontIsUploaded: false,
                        frontIsResolved: false,
                        showStartingPage: true
                    });
                    if (drivingLicenceDetails) {
                        _this.setState({
                            frontIsUKType: false
                        });
                    }
                }
                else if (_this.state.duplicateDriverFound) {
                    _this.setState({
                        frontIsUKType: true,
                        frontIsResolved: true
                    });
                }
                else {
                    for (var _i = 0, _b = Object.keys(drivingLicenceDetails); _i < _b.length; _i++) {
                        var detail = _b[_i];
                        if (_this.props.question.settings.interactionFields[detail] !== undefined) {
                            _this.props.onStateChange("".concat(_this.props.question.settings.interactionFields[detail]), drivingLicenceDetails[detail]);
                        }
                        if (detail === "fullAddress") {
                            _this.setState({
                                driverAddress: drivingLicenceDetails[detail]
                            });
                        }
                        if (detail === "licenceNumber") {
                            _this.setState({
                                licenceNumberFieldName: _this.props.question.settings.interactionFields[detail]
                            });
                        }
                    }
                    _this.setState({
                        frontIsUKType: true,
                        frontIsResolved: true
                    });
                    if (_this.validateLicenceNumber(drivingLicenceDetails)) {
                        _this.setState({
                            licenceNumberValid: true
                        });
                    }
                    _this.props.onStateChange("".concat(_this.props.question.settings.interactionFields["photoProvided"]), true);
                }
                _this.props.engine.setJourneyState((_a = {},
                    _a["".concat(_this.licenceID, "DLFrontResolved")] = _this.state.frontIsResolved,
                    _a["".concat(_this.licenceID, "DLFrontIsUKType")] = _this.state.frontIsUKType,
                    _a));
                _this.props.engine.validate();
                _this.toggleOverlay(false);
                _this.setState({ showStartingPage: true });
                _this.changelogRecorder.recordPage("change", _this.props);
            }, function () {
                var _a;
                _this.setState({
                    frontIsUploaded: false,
                    frontIsResolved: false,
                    showStartingPage: true
                });
                _this.props.engine.setJourneyState((_a = {},
                    _a["".concat(_this.licenceID, "DLFrontResolved")] = _this.state.frontIsResolved,
                    _a));
                _this.toggleOverlay(false);
            });
        }
    };
    ;
    ResolveDriversLicenceWidget.prototype.toggleUploadImageModal = function () {
        this.setState({ showUploadImageModal: !this.state.showUploadImageModal });
    };
    ResolveDriversLicenceWidget.prototype.exitUploadImageModal = function () {
        this.setState({
            showUploadImageModal: !this.state.showUploadImageModal,
            frontIsUploaded: false,
            showStartingPage: true
        });
    };
    ResolveDriversLicenceWidget.prototype.renderUploadedDrivingLicenceOutput = function (image) {
        var _this = this;
        var mobileDevice = this.isMobile();
        if (services_1.resourcesHelper.THEME === "Allianz") {
            return this.renderAZRebrandedUploadedDrivingLicenceOutput(image);
        }
        else {
            if (this.state.isMobileScreenSize) {
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "form-group", children: (0, jsx_runtime_1.jsxs)("div", { className: "dl-uploaded-image-panel-white " + this.getSetting("panelClass", ""), children: [image, (0, jsx_runtime_1.jsx)("input", { onKeyPress: mobileDevice ? function () { return _this.setState({ mobileUploadOptions: true }); } : this.getFrontFile, role: "button", tabIndex: -1, type: mobileDevice ? "radio" : "file", id: this.inputID, className: "dl-widget-upload-input", onChange: mobileDevice ? function () { return _this.setState({ mobileUploadOptions: true }); } : this.getFrontFile, "aria-label": "Choose file" }), (0, jsx_runtime_1.jsx)("label", { htmlFor: this.inputID, className: "btn btn-white dl-btn-next-width mb-0", role: "button", tabIndex: 0, children: "Change photo" }), (0, jsx_runtime_1.jsx)("button", { onClick: this.handleResolveFront, className: "btn btn-primary btn-add dl-btn-next-width", role: "button", tabIndex: 0, children: "Confirm" })] }) }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
            }
            else {
                return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: this.getSetting("panelClass", "dl-panel-white"), children: (0, jsx_runtime_1.jsxs)("div", { className: "dl-image-upload-panel", children: [image, (0, jsx_runtime_1.jsxs)("div", { className: "w-100", children: [(0, jsx_runtime_1.jsxs)("div", { className: "w-50 float-left change-photo-button", children: [(0, jsx_runtime_1.jsx)("input", { onKeyPress: mobileDevice ? function () { return _this.setState({ mobileUploadOptions: true }); } : this.getFrontFile, role: "button", tabIndex: -1, type: "file", id: this.inputID, className: "dl-widget-upload-input", onChange: mobileDevice ? function () { return _this.setState({ mobileUploadOptions: true }); } : this.getFrontFile }), (0, jsx_runtime_1.jsx)("label", { htmlFor: this.inputID, className: "btn btn-white dl-btn-next-width mb-0", role: "button", tabIndex: 0, children: "Change photo" })] }), (0, jsx_runtime_1.jsx)("div", { className: "confirm-photo-button", children: (0, jsx_runtime_1.jsx)("button", { onClick: this.handleResolveFront, className: "btn btn-primary btn-add dl-btn-next-width", role: "button", tabIndex: 0, children: "Confirm" }) })] })] }) }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
            }
        }
    };
    ResolveDriversLicenceWidget.prototype.renderAZRebrandedUploadedDrivingLicenceOutput = function (image) {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.exitUploadImageModal });
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal dl-image-upload-modal", isOpen: this.state.showUploadImageModal, toggle: this.exitUploadImageModal, backdrop: "static", children: [(0, jsx_runtime_1.jsx)(reactstrap_1.ModalHeader, { toggle: this.exitUploadImageModal, close: closeBtn, children: (0, jsx_runtime_1.jsx)("span", { className: "d-flex", children: "Upload your UK driving licence" }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "font-family-base font-weight-extra-light", children: (0, jsx_runtime_1.jsxs)("div", { className: "dl-image-upload-panel", children: [(0, jsx_runtime_1.jsx)("div", { className: "banner w-100 banner-info", children: (0, jsx_runtime_1.jsx)("div", { className: "banner-text", children: "We don't store or share your licence image." }) }), image, (0, jsx_runtime_1.jsx)("div", { className: "w-100", children: (0, jsx_runtime_1.jsx)("div", { className: "w-50 float-left change-photo-button", children: (0, jsx_runtime_1.jsx)("input", { onKeyPress: this.getFrontFile, role: "button", tabIndex: -1, type: "file", id: this.inputID, className: "dl-widget-upload-input", onChange: this.getFrontFile }) }) })] }) }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { children: (0, jsx_runtime_1.jsx)("div", { className: "w-100 d-flex flex-column justify-content-between", children: (0, jsx_runtime_1.jsxs)("div", { className: "button-container", children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: this.inputID, className: "btn btn-text", role: "button", tabIndex: 0, children: "Change photo" }), (0, jsx_runtime_1.jsx)("div", { className: "confirm-photo-button", children: (0, jsx_runtime_1.jsx)("button", { onClick: this.handleResolveFront, className: "btn btn-primary btn-add dl-btn-next-width", role: "button", tabIndex: 0, children: "Confirm" }) })] }) }) })] }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
    };
    ResolveDriversLicenceWidget.prototype.renderDrivingLicenceUpload = function () {
        var _this = this;
        var mobileDevice = this.isMobile();
        var adjective = this.licenceID && this.licenceID.includes("AD") ? "driver's" : "your";
        return ((0, jsx_runtime_1.jsxs)(React.Fragment, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.state.showInfo ? "info-box inner-content negative-margin width-auto" : ""), children: [(0, jsx_runtime_1.jsx)("div", { className: "text-group", children: this.getSetting("driverHeading", undefined) && (0, jsx_runtime_1.jsx)("h1", { children: this.getSetting("driverHeading", undefined) }) }), (0, jsx_runtime_1.jsx)("div", { className: this.getSetting("panelClass", "dl-panel-white"), children: (0, jsx_runtime_1.jsxs)("div", { className: "dl-image-upload-panel", children: [(0, jsx_runtime_1.jsx)("input", { onKeyPress: mobileDevice ? function () { return _this.setState({ mobileUploadOptions: true }); } : this.getFrontFile, role: "button", tabIndex: 0, type: mobileDevice ? "radio" : "file", id: this.inputID, className: "dl-widget-upload-input", onChange: mobileDevice ? function () { return _this.setState({ mobileUploadOptions: true }); } : this.getFrontFile }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center mb-3", children: (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsxs)("a", { className: "text-decoration-underline cursor-pointer text-blue-1 font-weight-semi-bold", onClick: this.focusOnFirstNameField, children: ["Enter ", adjective, " details below"] }), " or upload ", adjective, " ", (0, jsx_runtime_1.jsx)("b", { children: "UK driving licence to save " }), (0, jsx_runtime_1.jsxs)("span", { className: "info-button-container", children: [(0, jsx_runtime_1.jsx)("b", { children: " time" }), "\u00A0", (0, jsx_runtime_1.jsx)("div", { tabIndex: 0, onClick: this.showInfoHandler, className: this.state.showInfo ? "info-button selected" : "info-button" })] })] }) }), this.state.showInfo && this.renderDrivingLicenceUploadInfoText(), (0, jsx_runtime_1.jsx)("label", { htmlFor: this.inputID, "aria-label": "Add front of license", className: "btn btn-blue-dashboard btn-primary w-md-100", role: "button", tabIndex: 0, children: "Add front of licence" })] }) })] }), (0, jsx_runtime_1.jsx)(components_1.Overlay, { show: this.state.showOverlay })] }));
    };
    ResolveDriversLicenceWidget.prototype.capturePicture = function () {
        var _a;
        var canvas = document.createElement('canvas');
        var video = document.getElementById('video');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        canvas.getContext('2d').drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
        var file = canvas.toDataURL("image/jpeg");
        this.props.engine.setJourneyState((_a = {},
            _a["".concat(this.licenceID, "ImageExtensionIsCorrect")] = true,
            _a));
        this.setState({
            frontFile: {
                base64: file
            },
            frontIsUploaded: true,
            showStartingPage: false
        });
        this.stopVideoStream();
        this.props.engine.setJourneyState({ videoStreamEnabled: true });
    };
    ;
    ResolveDriversLicenceWidget.prototype.videoStreamIsDeclined = function (error) {
        console.log("Error occurred while accessing video stream: ", error.message);
        this.setState({
            videoStart: false,
            mobileUploadOptions: false
        });
        this.props.engine.setJourneyState({ videoStreamEnabled: false });
        this.props.engine.validate();
    };
    ;
    ResolveDriversLicenceWidget.prototype.isMobileOrTabletDevice = function () {
        var md = new MobileDetect(window.navigator.userAgent);
        if (md.mobile() || md.tablet()) {
            if (navigator.mediaDevices && typeof navigator.mediaDevices.getUserMedia === "function") {
                return true;
            }
        }
        return false;
    };
    ResolveDriversLicenceWidget.prototype.isMobile = function () {
        var dlMobileUploadType = process.env.REACT_APP_DL_FRONT_UPLOAD ? process.env.REACT_APP_DL_FRONT_UPLOAD : "desktop";
        // Check if environment variable for mobile is set and if UserMedia is present (not all IOs browsers have support for it)
        var isMobileDevice = JSON.stringify(dlMobileUploadType) === JSON.stringify("mobile");
        return this.isMobileOrTabletDevice() && isMobileDevice;
    };
    ResolveDriversLicenceWidget.prototype.disableFalconFooterAndBodyScrolling = function (disable) {
        if (!this.falconFooter && disable) {
            this.falconFooter = document.getElementsByClassName('falcon-footer');
        }
        if (this.falconFooter) {
            this.falconFooter[0].hidden = disable;
            document.getElementsByTagName('body')[0].style.overflow = disable ? "hidden" : "auto";
        }
    };
    ResolveDriversLicenceWidget.prototype.toggleOverlay = function (showOverlay) {
        this.setState({
            showOverlay: showOverlay
        });
    };
    ResolveDriversLicenceWidget.prototype.validateDuplicateDrivers = function (licenceNumber) {
        var _a;
        var _this = this;
        var interaction = this.props.interaction;
        if (licenceNumber == null) {
            this.setState({
                licenceNotResolved: true
            });
        }
        else if (interaction && (interaction.additionalDrivers || interaction.temporaryDrivers) && this.licenceID) {
            var licenceNumberToLowerCase_1 = licenceNumber.toLowerCase().replace('\\s', '');
            var driverIndex = this.licenceID.includes("AD") ? parseInt(this.licenceID.replace('AD', '')) - 1 : null;
            var policyHolder = interaction.policyHolder;
            if (interaction.additionalDrivers) {
                interaction.additionalDrivers.forEach(function (item) {
                    _this.drivers.push(item);
                });
                if (driverIndex != null && driverIndex >= 0) {
                    this.drivers.splice(driverIndex, 1);
                }
            }
            if (interaction.temporaryDrivers) {
                interaction.temporaryDrivers.forEach(function (tempDriver) {
                    _this.temporaryDrivers.push(tempDriver);
                });
                if (driverIndex == null) {
                    this.temporaryDrivers.splice(0, 1);
                }
            }
            if (this.drivers.some(function (driver) {
                if (driver != null && driver.licence != null && driver.licence.number != null) {
                    _this.drivers = [];
                    return driver.licence.number.toLowerCase().replace('\\s', '') === licenceNumberToLowerCase_1;
                }
                return false;
            })) {
                this.setState({
                    duplicateDriverFound: true
                });
            }
            else if (policyHolder.licence && policyHolder.licence.number &&
                policyHolder.licence.number.toLowerCase().replace('\\s', '') === licenceNumberToLowerCase_1) {
                this.drivers = [];
                this.setState({
                    duplicateDriverFound: true
                });
            }
            else {
                this.drivers = [];
                this.setState({
                    duplicateDriverFound: false
                });
            }
            this.props.engine.setJourneyState((_a = {},
                _a["".concat(this.licenceID, "DuplicateDriverFound")] = this.state.duplicateDriverFound,
                _a["".concat(this.licenceID, "LicenceNotResolved")] = this.state.licenceNotResolved,
                _a));
        }
    };
    ResolveDriversLicenceWidget.prototype.validateLicenceNumber = function (drivingLicenceDetails) {
        var licenceNumber = drivingLicenceDetails.licenceNumber;
        var licenceNumberFieldName = this.state.licenceNumberFieldName;
        var interaction = this.props.interaction;
        if (!licenceNumber) {
            journey_services_1.ObjectManipulator.setField(licenceNumberFieldName, interaction, null);
            return false;
        }
        var digitRegex = /^\d+$/;
        var alphanumericRegex = /^[a-z0-9]+$/i;
        var trimmedLicence = licenceNumber.replace(/ /g, '');
        if (alphanumericRegex.test(trimmedLicence) &&
            trimmedLicence.length === 18 &&
            drivingLicenceHelper_1.default.validateLastNameSection(drivingLicenceDetails.lastName, trimmedLicence.substring(0, 5).toUpperCase()) &&
            drivingLicenceHelper_1.default.validateBirthDateSection(drivingLicenceDetails.dateOfBirth, trimmedLicence.substring(5, 11).toUpperCase()) &&
            drivingLicenceHelper_1.default.validateFirstNameSection(drivingLicenceDetails.firstName, trimmedLicence.substring(11, 13).toUpperCase()) &&
            digitRegex.test(trimmedLicence.substring(13, 14)) &&
            digitRegex.test(trimmedLicence.substring(16))) {
            return true;
        }
        else {
            journey_services_1.ObjectManipulator.setField(licenceNumberFieldName, interaction, null);
            return false;
        }
    };
    ResolveDriversLicenceWidget.prototype.resize = function () {
        var currentIsMobile = (window.innerWidth < 768);
        if (currentIsMobile !== this.state.isMobileScreenSize) {
            this.setState({ isMobileScreenSize: currentIsMobile });
        }
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], ResolveDriversLicenceWidget.prototype, "changelogRecorder", void 0);
    __decorate([
        (0, core_1.lazyInject)(services_1.Types.FalconConvenienceApiService),
        __metadata("design:type", Object)
    ], ResolveDriversLicenceWidget.prototype, "falconConvenienceApiService", void 0);
    return ResolveDriversLicenceWidget;
}(plugin_journey_1.WidgetBase));
exports.ResolveDriversLicenceWidget = ResolveDriversLicenceWidget;
//# sourceMappingURL=ResolveDriversLicenceWidget.js.map